import * as Sentry from '@sentry/react'

import { APP_VERSION, SENTRY_DSN, SENTRY_ENVIRONMENT } from './constants'
import { isDev } from './utils/helpers'

if (!isDev) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: APP_VERSION,
    environment: SENTRY_ENVIRONMENT,
    integrations: [
      Sentry.httpClientIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
    sendDefaultPii: true,
  })
  const scope = Sentry.getCurrentScope()
  scope.setTag('origin', document.referrer)
}
